// src/features/auth/phone-verification/services/phoneVerificationService.ts

import {
  AUTH_ENDPOINTS,
} from '../../../../api';

import api from '../../../../api/axios';

import type {
  PhoneVerifyResponse,
  PhoneVerificationPurpose,
} from '../types/phoneVerification.types';


export const phoneVerificationService = {
  /**
   * =========================================================
   * 휴대폰 인증번호 발송
   *
   * POST /api/v2/auth/phone/send
   *
   * Body
   * {
   *   phoneNumber,
   *   purpose
   * }
   * =========================================================
   */
  async send(
    phoneNumber: string,
    purpose:
      PhoneVerificationPurpose,
  ): Promise<void> {
    const normalizedPhoneNumber =
      phoneNumber
        .replace(
          /\D/g,
          '',
        )
        .trim();


    if (
      !normalizedPhoneNumber
    ) {
      throw new Error(
        '전화번호가 필요합니다.',
      );
    }


    await api.post(
      AUTH_ENDPOINTS
        .PHONE
        .SEND,
      {
        phoneNumber:
          normalizedPhoneNumber,

        purpose,
      },
    );
  },


  /**
   * =========================================================
   * 휴대폰 인증번호 확인
   *
   * POST /api/v2/auth/phone/verify
   *
   * Body
   * {
   *   phoneNumber,
   *   verificationCode,
   *   purpose
   * }
   *
   * Response
   * {
   *   verificationToken
   * }
   * =========================================================
   */
  async verify(
    phoneNumber: string,
    verificationCode: string,
    purpose:
      PhoneVerificationPurpose,
  ): Promise<
    PhoneVerifyResponse
  > {
    const normalizedPhoneNumber =
      phoneNumber
        .replace(
          /\D/g,
          '',
        )
        .trim();


    const normalizedVerificationCode =
      verificationCode
        .replace(
          /\D/g,
          '',
        )
        .trim();


    if (
      !normalizedPhoneNumber
    ) {
      throw new Error(
        '전화번호가 필요합니다.',
      );
    }


    if (
      !normalizedVerificationCode
    ) {
      throw new Error(
        '인증번호가 필요합니다.',
      );
    }


    const response =
      await api.post<
        PhoneVerifyResponse
      >(
        AUTH_ENDPOINTS
          .PHONE
          .VERIFY,
        {
          phoneNumber:
            normalizedPhoneNumber,

          verificationCode:
            normalizedVerificationCode,

          purpose,
        },
      );


    return response.data;
  },
};